import { render } from "./FeederCuCal.vue?vue&type=template&id=b738286c"
import script from "./FeederCuCal.vue?vue&type=script&lang=js"
export * from "./FeederCuCal.vue?vue&type=script&lang=js"
script.render = render

export default script